import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ClickUpTaskButton = ({
  taskId,
  label = 'ClickUp',
  size = 'sm',
  variant = 'outline',
  className = '',
  iconOnly = false,
}) => {
  if (!taskId) return null;

  return (
    <a
      href={`https://app.clickup.com/t/${taskId}`}
      target="_blank"
      rel="noreferrer"
      onClick={event => event.stopPropagation()}
      title="Open in ClickUp"
      className="inline-flex"
    >
      <Button size={size} variant={variant} className={className}>
        <ExternalLink className={iconOnly ? 'w-3.5 h-3.5' : 'w-3.5 h-3.5 mr-1.5'} />
        {!iconOnly && label}
      </Button>
    </a>
  );
};

export default ClickUpTaskButton;
